import React from 'react';
import { Checkbox, Col, Row } from 'antd';
import { CheckboxOptionType } from 'antd/es/checkbox/Group';
import { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon';
import { defaultFieldLayout } from './defaultFieldLayout';
import cx from 'classnames';
import { IFieldLayout, IMultiEnabled } from '../../interfaces';
import { falseString, sortTextArrayByDict, subscribersFeaturesDict, upperCaseFirstLetter } from '../../instruments';
import { formatDataTestAttribute } from '../../instruments/testing';
import { ITrField, tF } from '../../translate';
import { Catcher } from '../Catcher';
import Styles from '../styles/m_itemCardStyles.less';

type IMultiCheckboxShowField = {
    children?: never;
    dataTest?: string;
    icon?: React.ReactElement<AntdIconProps>;
    isHidden?: boolean;
    isIconBlank?: boolean;
    layout?: IFieldLayout;
    title?: ITrField;
    titleSuffix?: React.ReactNode;
    values?: IMultiEnabled;
};

const CheckboxGroup = Checkbox.Group;

export const MultiCheckboxShowField: React.FC<IMultiCheckboxShowField> = ({
    dataTest = '',
    icon,
    isHidden,
    isIconBlank,
    layout,
    title,
    titleSuffix,
    values = {},
}: IMultiCheckboxShowField) => {
    if (isHidden) {
        return null;
    }
    const MyLayout: IFieldLayout = { ...defaultFieldLayout, ...layout };

    const names: Array<string> = sortTextArrayByDict(Object.keys(values), subscribersFeaturesDict);

    const options: Array<CheckboxOptionType> = names?.map(
        (i: string): CheckboxOptionType => ({ label: upperCaseFirstLetter(i), value: i }),
    );

    const value: Array<string> = names
        .map((i: string): string => {
            return values[i].enabled ? i : falseString;
        })
        .filter((i: string): boolean => i !== falseString);

    return (
        <Catcher>
            <Row gutter={MyLayout.rowGutter} className={Styles.showAdvancedField}>
                <Col {...MyLayout.labelCol} className={cx(Styles.label, Styles.labelTextArea)}>
                    {icon ? icon : null}
                    <div
                        className={cx({ [Styles.labelText]: !!icon || isIconBlank })}
                        data-test={formatDataTestAttribute(dataTest, 'MultiCheckboxShowField', 'Title')}
                    >
                        {title ? tF(title) : null}: {titleSuffix ? titleSuffix : null}
                    </div>
                </Col>
                <Col
                    {...MyLayout.valCol}
                    className={Styles.value}
                    data-test={formatDataTestAttribute(dataTest, 'MultiCheckboxShowField', 'Data')}
                >
                    <CheckboxGroup options={options} value={value} disabled />
                </Col>
            </Row>
        </Catcher>
    );
};
